export const customStyles = {
  table: {
    style: {
      backgroundColor: '#000000',
      color: '#ffffff',
    },
  },
  header: {
    style: {
      backgroundColor: '#000000',
      color: '#ffffff',
    },
  },
  headRow: {
    style: {
      backgroundColor: '#000000',
      color: '#ffffff',
      borderBottomColor: '#333333',
      borderBottomWidth: '1px',
    },
  },
  headCells: {
    style: {
      color: '#ffffff',
      fontSize: '14px',
      fontWeight: '600',
      textTransform: 'uppercase',
      paddingLeft: '16px',
      paddingRight: '16px',
    },
  },
  rows: {
    style: {
      backgroundColor: '#000000',
      color: '#ffffff',
      '&:not(:last-of-type)': {
        borderBottomColor: '#333333',
        borderBottomWidth: '1px',
      },
      minHeight: '64px',
      paddingLeft: '8px',
      paddingRight: '8px',
    },
    highlightOnHoverStyle: {
      backgroundColor: '#1a1a1a',
      color: '#ffffff',
      transitionDuration: '0.15s',
      transitionProperty: 'background-color',
      borderBottomColor: '#333333',
      outline: 'none',
    },
  },
  pagination: {
    style: {
      backgroundColor: '#000000',
      color: '#ffffff',
      borderTopColor: '#333333',
      borderTopWidth: '1px',
    },
    pageButtonsStyle: {
      color: '#ffffff',
      fill: '#ffffff',
      '&:disabled': {
        color: '#333333',
        fill: '#333333',
      },
      '&:hover:not(:disabled)': {
        backgroundColor: '#333333',
      },
      '&:focus': {
        outline: 'none',
        backgroundColor: '#333333',
      },
    },
  },
  noData: {
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#9ca3af',
      backgroundColor: '#000000',
      padding: '48px',
    },
  },
  progress: {
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#ffffff',
      backgroundColor: '#000000',
      padding: '48px',
    },
  },
};
